// extracted by mini-css-extract-plugin
module.exports = {"rightChat":"-G2rG","chatCon":"_3tF2R"};